import { LIMITS } from "@/commands/answers/collect-answers-constants";
import { CliError } from "@/lib/cli/cli-error";

export function validateSelectedOptionIds(
  options: string[] | undefined,
  label: string,
): void {
  if (options === undefined) {
    return;
  }
  if (options.length > LIMITS.OPTIONS_PER_ANSWER) {
    throw new CliError(
      `${label} selects more than ${LIMITS.OPTIONS_PER_ANSWER} options.`,
      2,
    );
  }
  for (const id of options) {
    if (id.trim().length === 0) {
      throw new CliError(`${label} has an empty option id.`, 2);
    }
    if (id.trim().length > LIMITS.OPTION_ID) {
      throw new CliError(
        `${label} has an option id longer than ${LIMITS.OPTION_ID} characters.`,
        2,
      );
    }
  }
}
